/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';

import {
  HeadingContainer, StatsGraphHeading, NoResultsHeading, LoadingSpinner,
} from '../Styles';
import DateFilterDropdown from '../DateFilterDropdown';
import PieChartGraph from '../PieChart';

import useStrings from '../../../../hooks/useStrings';
import { useGetTopDonationTypes } from '../../../../lib/graphql/queries';
import { displayDonationType, fromDate } from '../../../../lib/Utils';

const TopDonationTypes: React.FC<TopDonationTypesProps> = () => {
  const [{ Statistics: strings }] = useStrings();

  const [showDateFilter, setShowDateFilter] = useState(false);
  const [filterSelected, setFilterSelected] = useState<'week' | 'month' | 'year'>('week');

  const { data: topDonationsData, loading } = useGetTopDonationTypes({
    variables: { fromDate: fromDate(filterSelected) },
  });
  const topDonationTypes = topDonationsData?.topDonationTypes.donationTypes.map((type) => (
    {
      name: displayDonationType(type.type),
      value: type.count,
    }
  )) || [];

  return (
    <>
      <HeadingContainer>
        <StatsGraphHeading>{strings.donationTypes}</StatsGraphHeading>
        <DateFilterDropdown
          onToggleDropdown={() => setShowDateFilter(!showDateFilter)}
          isDropdownShown={showDateFilter}
          onClickFilter={setFilterSelected}
          filterSelected={filterSelected}
        />
      </HeadingContainer>
      {loading
        ? <LoadingSpinner />
        : topDonationTypes.length === 0
          ? <NoResultsHeading>{strings.noResults}</NoResultsHeading>
          : <PieChartGraph data={topDonationTypes} />}
    </>
  );
};

interface TopDonationTypesProps { }

export default TopDonationTypes;
